document.addEventListener('DOMContentLoaded',function(){
  const menuBtn=document.querySelector('[data-mhc-menu]');
  const mobile=document.querySelector('.mhc-mobile-nav');
  if(menuBtn&&mobile){menuBtn.addEventListener('click',function(){const open=mobile.classList.toggle('is-open');menuBtn.setAttribute('aria-expanded',open?'true':'false');});}
  document.querySelectorAll('[data-mhc-product]').forEach(function(root){
    const dataEl=root.querySelector('[data-product-variants]'); if(!dataEl)return;
    let variants=[]; try{variants=JSON.parse(dataEl.textContent)}catch(e){return;}
    const selects=[...root.querySelectorAll('[data-mhc-option]')];
    const idInput=root.querySelector('input[name="id"]');
    const priceEl=root.querySelector('[data-price]');
    const button=root.querySelector('.mhc-atc');
    const atcLabel=root.querySelector('[data-atc-label]');
    const atcPrice=root.querySelector('[data-atc-price]');
    const formatter=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
    function update(){
      const selected=selects.map(s=>s.value);
      const variant=variants.find(v=>selected.every((val,i)=>v.options[i]===val));
      if(!variant)return;
      if(idInput)idInput.value=variant.id;
      const money=formatter.format(variant.price/100);
      if(priceEl)priceEl.textContent=money;
      if(button)button.disabled=!variant.available;
      if(atcLabel)atcLabel.textContent=variant.available?'Add to bag':'Sold out';
      if(atcPrice)atcPrice.textContent=variant.available?' — '+money:'';
      const url=new URL(window.location.href); url.searchParams.set('variant',variant.id); window.history.replaceState({},'',url);
    }
    root.querySelectorAll('[data-mhc-option-group]').forEach(function(group){
      const select=group.querySelector('[data-mhc-option]');
      group.querySelectorAll('[data-mhc-value]').forEach(function(chip){chip.addEventListener('click',function(){
        group.querySelectorAll('[data-mhc-value]').forEach(c=>c.classList.remove('is-selected'));
        chip.classList.add('is-selected'); select.value=chip.dataset.mhcValue; update();
      });});
    });
    selects.forEach(s=>s.addEventListener('change',update)); update();
  });
});